import { Controller } from '@hotwired/stimulus'
import Chart, { ChartItem, ChartConfiguration } from 'chart.js/auto'

interface DistributionRow {
  name: string
  count: number
  color: string
}

type RowsByPhase = Record<string, DistributionRow[]>

export default class extends Controller {
  chart: Chart | null = null

  static targets = ['canvas', 'radio']
  static values = {
    rowsByPhase: Object,
    yAxisTitle: String
  }

  declare readonly canvasTarget: HTMLCanvasElement
  declare readonly radioTargets: HTMLInputElement[]
  declare rowsByPhaseValue: RowsByPhase
  declare yAxisTitleValue: string

  connect (): void {
    const rows = this.currentRows()

    const configuration: ChartConfiguration = {
      type: 'bar',
      data: {
        labels: rows.map(({ name }) => name),
        datasets: [
          {
            data: rows.map(({ count }) => count),
            backgroundColor: rows.map(({ color }) => color),
            barPercentage: 0.4,
            borderRadius: 4
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: this.yAxisTitleValue },
            ticks: { precision: 0 }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    }

    this.chart = new Chart(this.canvasTarget as ChartItem, configuration)
  }

  switchPhase (): void {
    if (this.chart == null) return

    this.chart.data.datasets[0].data = this.currentRows().map(({ count }) => count)
    this.chart.update()
  }

  disconnect (): void {
    this.chart?.destroy()
    this.chart = null
  }

  private currentRows (): DistributionRow[] {
    const selected = this.radioTargets.find(radio => radio.checked)?.value

    return selected != null ? this.rowsByPhaseValue[selected] ?? [] : []
  }
}
